import type { DrawerProps } from '@meterup/atto';
import {
  atContainers,
  containers,
  containerValues,
  Drawer as AttoDrawer,
  styled,
  zIndexes,
} from '@meterup/atto';
import { createPortal } from 'react-dom';

const DrawerContainer = styled('div', {
  position: 'absolute',
  zIndex: zIndexes.drawer,
  top: 0,
  right: 0,
  bottom: 0,
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  gridTemplateAreas: '"drawer"',
  justifyContent: 'flex-end',
  transition: 'transform 0.2s ease-in-out',
  pointerEvents: 'none',

  '@notDesktop': {
    left: 0,
  },

  '@desktop': {
    widthAll: `$${containerValues.drawer}`,

    ...atContainers([containers.stage.narrow], {
      position: 'absolute',
      top: '$12',
      right: '$12',
      bottom: '$12',
      heightAll: 'auto',
    }),
  },

  variants: {
    open: {
      true: {
        transform: 'translateX(0)',
      },
      false: {
        transform: 'translateX(120%)',
      },
    },
  },
});
DrawerContainer.displayName = 'DrawerContainer';

export function DrawerPortal({
  children,
  ...remaining
}: { children: React.ReactNode } & DrawerProps) {
  const mount = document.getElementById('drawer-portal');

  if (!mount) {
    return null;
  }

  return createPortal(<AttoDrawer {...remaining}>{children}</AttoDrawer>, mount);
}

export function Drawer({ children, open = false }: { children: React.ReactNode; open: boolean }) {
  return (
    <>
      <DrawerContainer open={open}>{children}</DrawerContainer>
      <DrawerContainer open id="drawer-portal" />
    </>
  );
}
